import { Grid, Column, Title as TitleBase } from '@bidalihq/ui';
import tw from 'tailwind-styled-components';

import MaxWidth from '@/components/max-width';
import Button from '@/components/button';

const Container = tw.div`
  relative
`;

const Bermuda = tw.div`
  bg-[linear-gradient(300deg,transparent_10%,#F6DACF_70%),url('/images/BM.jpg')]
  bg-cover
  bg-center
  absolute
  top-0
  left-0
  h-full
  w-full

  lg:bg-[linear-gradient(185deg,transparent_10%,#F6DACF_70%),url('/images/BM.jpg')]
  lg:w-2/3
`;

const Alberta = tw(Bermuda)`
  bg-[linear-gradient(170deg,transparent_10%,#CBB6A1_70%),url('/images/AB.jpg')]
  [clip-path:polygon(0_0,_100%_0,_100%_60%,_0_40%)]
  left-auto
  right-0

  lg:w-full
  lg:[clip-path:polygon(45%_0,_100%_0px,_100%_100%,_55%_100%)]
  lg:bg-[linear-gradient(170deg,transparent_20%,#CBB6A1_70%),url('/images/AB.jpg')]
`;

const Title = tw(TitleBase)`
  !leading-none
  font-inter
  text-slate-700
  mb-12
`;

const Paragraph = tw.p`
  text-2xl
  text-slate-700
  font-medium
  mb-8
`;

const Location = () => {

  return (
    <Container>
      <Bermuda />
      <Alberta />
      <MaxWidth className="relative z-10 lg:py-24 lg:px-0 p-8">
        <Title>Based in Bermuda & Canada.<br />Built with ❤️ around the world.</Title>
        <Grid columns={[1, 1, 2]}>
          <Column>
            <Paragraph>Bidali is a remote-first team that embraces decentralization. It’s in our fabric. Born out of necessity, we’ve come together to transform the way people transact around the world and without borders.</Paragraph>
            <Paragraph>Interested in helping us build a more open global economy?</Paragraph>
            <Button className="block w-fit mx-auto" to="/careers/" size="large" variant="secondary">
              Join the Team
            </Button>
          </Column>
          <Column />
        </Grid>
      </MaxWidth>
    </Container>
  );
};

export default Location;
